
import confetti from 'canvas-confetti';
import  React,{ useEffect, useState } from "react";
import {useStateContext} from '../context/StateContext';
import lang from "../JSON-FILES/lang.json"
import Swal from "sweetalert2"
import { v4 as uuidv4, v4 } from 'uuid';
import { logDoc, deviceNonConformityDoc } from '../components/gestioneDatabase/Docs';
import { urlFor } from './client';
import deadlines from '../components/Deadlines';
import { toast } from 'react-hot-toast';
import imageCompression from 'browser-image-compression'; // Import image compression library
import { HiddenOfferData } from '../components/offerComponents/HiddenOfferData';

const P = "utils"


export const registerIdsFromOfferFields = (offerFields = []) => {
  if(!Array.isArray(offerFields)) return []
  const uniqueRegisters = !Array.isArray(offerFields) ? [] : unique("registerId", offerFields)?.map?.((x)=>x?.registerId)
  const isThereSigns = offerFields?.find?.((x)=>x?.isSign)

  if(isThereSigns) return [...uniqueRegisters, "weduwheiudghyegwuyjke88363ghdloiejdf87"]
  return unique("registerId", offerFields)?.map?.((x)=>x?.registerId)
}
  /**
   * @function
   * @param {object} deviceFieldValue - The field with the value to be returned
   * @param {object} registerTemplate - The register template from which the dropdown values are taken
   * @param {boolean} [showValue=false] - If true, the value of the field list is returned
   * @param {boolean} [showTemplate=false] - If true, the whole field list object is returned
   * @returns {string|object} The value of the field list corresponding to the device field value, or the device field value itself if no match is found
   */
export const templateDeviceValue = (deviceFieldValue, registerTemplate, showValue=false, showTemplate=false) => {

  const valueId = deviceFieldValue?._id

  const fields = !Array.isArray(registerTemplate?.fields) ? [] : registerTemplate?.fields?.length > 0 ? registerTemplate?.fields : []
  const locations = !Array.isArray(registerTemplate?.locations) ? [] : registerTemplate?.locations?.length > 0 ? registerTemplate?.locations : []
  const dataModules = [fields, locations].flat().filter?.((x)=>x?.fieldType == "dropdown")
  const lists = dataModules.map?.((y)=> y?.lists).flat()
  const fieldLists = !Array.isArray(lists) ? [] : lists.map?.((z)=> z?.fieldList).flat()

  const findFieldList = fieldLists?.find?.((l)=>l?._id == valueId)
  
  if(findFieldList) return findFieldList?.label
  if(findFieldList && showValue ) return findFieldList?.value
  if(findFieldList && showTemplate ) {
    console.log("returned")
    return (findFieldList)}
  return deviceFieldValue?.value
}

  /**
   * 
   * @function
   * @param {object} reference - The object containing the _ref field to be matched
   * @param {array} referenceLocationArray - The array of objects containing the _id field to be matched
   * @returns The matched object from the referenceLocationArray if the _ref from the reference matches the _id of an object in the array
   * 
   * This function takes a reference object and an array of objects and returns the object from the array that matches the _ref field of the reference.
   * 
   * The function is used to expand a reference to a document in an array to the actual document inside the array.
   * 
   * The function is used in the following components:
   * - DevicePin.jsx
   * - Registers.jsx
   * - Wheel.jsx
   */
export const expandReference = (reference, referenceLocationArray) => {
  //console.log("expandReference:", reference)
  let _ref = reference?._ref
  //console.log("_ref:", _ref)
  //console.log("referenceLocationArray:", referenceLocationArray)

  const matchedDevice = () => !Array.isArray(referenceLocationArray) ? undefined : referenceLocationArray?.find?.((x)=> x._id ==_ref)

  //console.log("matchedDevice:", matchedDevice())

  return matchedDevice()

}

export const matchTemplateFieldWithValue = (fieldId, fieldsArray, templateDevice, monthYear) => {  

  //console.log("matchTemplateField")
  
  if(!fieldsArray){
    //console.log("array non trovato")
    return({value:""})} else {
      //console.log("array:",fieldsArray)
    }

  const match = () => !Array.isArray(fieldsArray) ? undefined : fieldsArray?.find?.((x)=>{
      return x?.templateField?._ref == fieldId
  
   })

   const values = match()?.values
   //console.log("match:", values.length)

   
  if(values?.length==0) {
    //console.log("trovato = 0", values)
    return {value:""}}

  if(values?.length==1) {
    //as I cannot define isDate in any other waty at the moment, I excluded these fields
    if (match()?.templateField?._ref == "5710d994-8bc9-4981-a5af-94a535d27bbd") return (values?.[0])
    if (match()?.templateField?._ref == "f0fd3f90-ef02-4dae-a4df-dfff44aba409") return (values?.[0])
      
    const templateValue = templateDeviceValue(values?.[0], templateDevice)
   // const isDate = templateDevice?.dates?.some?.((x)=>x?._id == fieldId)
    const isDate = (Number(templateValue) > 1970 &&  Number(templateValue) < 2200) ? true : false 
    const obj = values?.[0]?.dateObject
    const isYearANumber = Number(templateValue) ? Number(templateValue) : undefined;
/*     if(templateDevice) {
      console.log("trovato = 1", {value: values?.[0], templateDevice, templateValue, fieldsArray, match: match()})
    }
    */
    if(monthYear){
      if(obj){
        //console.log("djnskjndskjdn", values?.[0], templateValue, match())
        return ({value: !obj?.year ? undefined : `${obj?.month ? obj?.month : 1}/${obj?.year}`, dateObject: obj})
      }
      if(!obj & isDate) {
    
        return(
        {
          value: !isYearANumber ? undefined : `1/${templateValue}`, 
          dateObject: !isYearANumber ? undefined : {month:1, year: Number(templateValue)}}
      )}
     
      //if(obj) 
      //
    }
    return {value: templateValue}
  }
  
  if(values?.length>1) {
    
    const printedValues = values.map?.((value)=>" "+value?.value)
    //console.log("more than one", printedValues ) 
    // old return printedValues?.toString()
    return ({value:printedValues?.toString()})
  }

  /*
  if(match()?.value) {
   //console.log("matched:",match().value)
  return match().value }
*/
}


export const sortLabelCompare = ( a, b ) => {
  if ( a?.label < b?.label ){
    return -1;
  }
  if ( a?.label > b?.label ){
    return 1;
  }
  return 0;
}



export const initialValue = (currentDevice, field, deviceFields, currentTemplate) => { 
  if (currentDevice?._id){
      //const fieldsArray = [...currentDevice?.locations,...currentDevice?.fields]
      //console.log("fieldsaaray",fieldsArray)
      //console.log("CurrentDevice",currentDevice?.locations)
      //console.log("Item",field)
      //console.log ("currentTemplate", currentTemplate.fields)
      let matchString = matchTemplateFieldWithValue(field?._id, deviceFields, currentTemplate)?.value
      //console.log("match", match)
      const match = !Array.isArray(deviceFields) ? undefined : deviceFields?.find?.((x)=>x?.templateField?._ref===field?._id)
      //console.log("matchXXX", match)

      if (match?.values?.length == 1 && !field?.isMulti && field?.fieldType=="dropdown"){
          const templateValue = templateDeviceValue(match?.values?.[0], currentTemplate, false, true)
          //console.log("match = 1", match?.values?.[0], templateValue )
          return({...match?.values?.[0], label: matchString, value: matchString })
          
      }  
     else if (match?.values?.length > 0 && field?.isMulti && field?.fieldType=="dropdown"){
          //console.log("match = 1 Multi", match, item.label)
          return([...match?.values]) 
      } 
      else if (field?.fieldType=="boolean") {
          //console.log("boolean", matchString, field.label)
          return matchString ? true : false 
      }
      else {
          //console.log("default", matchString, item.label)
          return matchString 
      }

  }
  return undefined

}
      /**
       * designed to return true only if every item in the targetArray is present in the sourceArray, 
       * using optional keys (sourceKey and targetKey) if the arrays contain objects.
       * if both arrays are empty returns false
       *  #showHideOffer
       * @param {*} param0 
       * @returns 
       */
     export const allArrayDataInTargetArray = ({ sourceArray=[], sourceKey, targetArray=[], targetKey }) => {
        const isObject = (val) => val !== null && typeof val === 'object';

        // Validate source array structure
        if (sourceKey) {
          const invalidSource = sourceArray?.find?.(item => !isObject(item) || !(sourceKey in item));
          if (invalidSource) {
            throw new Error(`Invalid item in sourceArray: Expected object with key '${sourceKey}', got: ${JSON.stringify(invalidSource)}`);
          }
        } else {
          const invalidSource = sourceArray?.find?.(item => isObject(item));
          if (invalidSource) {
            throw new Error(`Invalid item in sourceArray: Expected primitive, got object: ${JSON.stringify(invalidSource)}`);
          }
        }

        // Validate target array structure
        if (targetKey) {
          const invalidTarget = targetArray?.find?.(item => !isObject(item) || !(targetKey in item));
          if (invalidTarget) {
            throw new Error(`Invalid item in targetArray: Expected object with key '${targetKey}', got: ${JSON.stringify(invalidTarget)}`);
          }
        } else {
          const invalidTarget = targetArray?.find?.(item => isObject(item));
          if (invalidTarget) {
            throw new Error(`Invalid item in targetArray: Expected primitive, got object: ${JSON.stringify(invalidTarget)}`);
          }
        }
        if(sourceArray?.length == 0 && targetArray?.length == 0) return false
        if (!sourceArray?.length || !targetArray?.length) return false;
        // Proceed with main logic
        const sourceArraySet = new Set(
          sourceArray?.map?.(obj => (sourceKey ? obj[sourceKey] : obj))
        );

        return targetArray?.every?.(obj => sourceArraySet?.has(targetKey ? obj[targetKey] : obj));
      };

export const fieldVisibleByDevice = (item, currentDevice, deviceFields) => {
  const {devices, devicesExclude, deviceProperties, propertiesExclude} = item 
  
  const locations = !currentDevice?.locations ? []: currentDevice?.locations
  const dates = !currentDevice?.dates ? []: currentDevice?.dates
  const fields = !currentDevice?.fields ? []: currentDevice?.fields
  const allProperties = [...fields, ...locations, ...dates ]
  
  const currentDeviceId = currentDevice._id

//================DEVICE & NO PROPERTIES========================== 

  if(devices && (deviceProperties?.length<1|| !deviceProperties)){

     if(devices.length>0){
  
      const result = devices.some?.(obj=> obj._ref === currentDeviceId)
      
      if(result){
        if(!devicesExclude) return true
        if(devicesExclude) return false
      }
      if(!result){
        if(!devicesExclude) return false
        if(devicesExclude) return true
      }
       return false
     
    }
     return true
    
  }
   //================PROPERTIES & NO DEVICES==========================
   
   if(devices?.length<=0 && deviceProperties ){
    
    if(deviceProperties.length>0){
      
     const result = deviceProperties.some?.((obj)=>{ 
      
      return deviceFields.some?.(x=> obj?._ref == x?.values?.[0]?._id) 
    })
    //console.log("testing now", deviceFields)
    //console.log("device Properties", deviceProperties)
     
     if(result){
       if(!devicesExclude) return true
       if(devicesExclude) return false
     }
     if(!result){
       if(!devicesExclude) return false
       if(devicesExclude) return true
     }
      return false
    
   }
    return true
   
 }

 // Options with both properties and devices
 // deviceProperties?.length>0 && deviceProperties?.length>0

  return true
  }





/**
 * 
 * @param {*} item needs to include the following fields: deviceDependant, and lists or value.
 * it is designed to work with _type dataModule
 * @param {*} currentDevice the device to compare the lists with
 * @returns a list of options for the dropdown menu
 */


export const listOptions = (item, currentDevice) => {

  const {deviceDependant, lists, value} = item
  //console.log("Current Device" , currentDevice)
  //console.log("Item ej3uje3iej" , item)

  if(lists.length>1){
    //console.log("DEVICE DEP && LISTS")
    
     
      //console.log("DEVICE DEP && LISTS > 1")     
        
      const list = () => {    
          //console.log("In Const", lists)
          let array = []
          lists?.map?.((obj)=>{
              const {devices,_ref,_key, fieldList } = obj
             // console.log("obj:",obj )
              const match = devices?.findIndex((device)=>{
                  //console.log("obj ref:",device._ref, "curr dev id:",currentDevice._id )
                  return device._ref === currentDevice._id
              })
              //console.log("matched:",match)
              //if(currentDevice._id==item.)
              const key = _key
              if(match>-1){    
                  array = fieldList 
              } 
              
              //return array
          }
          )
          //console.log("item matched:",array)
          return array
      }

      return list()   
  }
  
  else if(lists.length == 1){
      let array = lists[0].fieldList
      return array }
  else if(value){
      //setVisible(false)
      let array = [{label: value}]
      return array}
  else {
    return ["LISTA NON TROVATA, CONTROLLARE ASSEGNAZIONE LISTE"]
  }
  }


export const listToLabelValue =(array=[])=>{
  
  let newArray = []
   array?.map?.((item)=>{ newArray = [...newArray,  {label:item}]
  })

  return newArray
  
  
}
/**
 * 
 * @param {*} field a string that matches the fiels in the array element that I want to turn int label and value
 * @param {*} array array to which I wanna add lable and value
 * @returns 
 */
export const addValueAndValueForDropdown = (field, array) => array?.map?.((list)=>({...list, label:list[field], value:list[field]}))

export const addValueForDropdown = (clientsArray=[]) =>{
  let newArrayClients = []
  clientsArray?.length > 0 && clientsArray
      ?.map?.((item) => {
        const key = item?.key

          newArrayClients = [
             ...newArrayClients, {
                  ...item,
                  value: item?.label
              }
          ]

      })    
      return newArrayClients
    }

export const runFireworks = () => {
  var duration = 5 * 1000;
  var animationEnd = Date.now() + duration;
  var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  var interval = setInterval(function() {
    var timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    var particleCount = 50 * (timeLeft / duration);
    // since particles fall down, start a bit higher than random
    confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
    confetti(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
  }, 250);
}

/** It gets the user information stored in the local storage. If it is not found, it clears
 * the local storage
 */

export const fetchUser = () => {

  const userInfo = localStorage.getItem('user') !== 'undefined'
      ? JSON.parse(localStorage.getItem('user'))
      : localStorage.clear();
      
      //console.log("fetch user info: ",userInfo)

      return userInfo

}

export const allTemplateNonConformities = (template, nonConformities=[]) => {
  //const {nonConformities} = useStateContext();
  const generatedNonConformities = template?.fields
  ?.filter?.((x)=>x.fieldGeneratedNonConformity)
  .map?.((item)=>item.nonConformities)
  .flat(1)
  const maintenanceNonConformities = template?.dates
  ?.filter?.((x)=>x.fieldGeneratedNonConformity)
  .map?.((item)=>item.nonConformities)
  .flat(1)
  
  
  const templateNonConformities = Array.isArray(nonConformities) ? nonConformities?.filter?.((x)=>{
    const registerFound = !Array.isArray(x?.registers) ? undefined : x?.registers?.find?.((y)=>y?._ref==template?._id)
    return template?._id == registerFound?._ref
  }) : []


  const templateFieldNonConformities = generatedNonConformities ? generatedNonConformities : []
  const templateMaintenanceNonConformities = maintenanceNonConformities ? maintenanceNonConformities : []
  const allTemplateNonConformities = [...templateNonConformities,...templateFieldNonConformities, ...templateMaintenanceNonConformities]
  return allTemplateNonConformities
}

export const userLogCheck = (device, logType = "check") => {
  const checkDates = !Array.isArray(device?.userLog) ? [] : device?.userLog?.filter?.(x=>x?.logType == logType).map?.((item)=>{
    return item.date
}).sort(function(a, b){return b - a})

const lastCheckDate = checkDates && checkDates[0]
const lastCheck = !Array.isArray(device?.userLog) ? [] : device?.userLog?.filter?.(x=>x?.logType ==logType)?.find?.((x)=>x.date==lastCheckDate)
//console.log("lawehjdlqaewhc",lastCheckDate )
return ({
  date: lastCheckDate,
  log: lastCheck
})
}

export const sortDevices = (a,b,sortType) => {

  let templateId

  switch(sortType){
      case "Piano": 
      //console.log("in Piano")
      templateId = "100089e6-e85d-467f-92b2-958628470ea2"
      break
      default :
      //console.log("in Default")
      templateId = "5710d994-8bc9-4981-a5af-94a535d27bbd"

  }
  const sortByNumeric = ( a, b ) => {
   if(!a || !b) return undefined
    return a?.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}
  
  const sortValue = (device={}, id) => {
      const locations = !device?.locations ? [] : device?.locations
      const fields = !device?.fields ? [] : device?.fields
      const array =[...locations,...fields]
      const obj = !Array.isArray(array) ? undefined : array?.find?.(x=>x.templateField._ref == id)
      const value = obj?.values?.[0].value
      return !value ? 0 : value
  }

  const firstElement = sortValue(a, templateId) ? sortValue(a, templateId)?.toLowerCase() : 0
  const secondElement = sortValue(b, templateId) ? sortValue(b, templateId)?.toLowerCase() : 0
  
  //console.log("first", firstElement,"second",secondElement)

/*     if(sortType!=="Posizione") {
        if (firstElement?.toLowerCase()>secondElement.toLowerCase()) return 1
        if (firstElement?.toLowerCase()<secondElement.toLowerCase()) return -1
        return 0
    }
      
  return(
      firstElement - secondElement
  ) */
  return sortByNumeric(firstElement, secondElement )

}

// DATE OBJECT FUNCTIONS {year, month}

export const formatDateFromDateObject = (dateObject) => {
  return `${dateObject?.month}/01/${dateObject?.year}`
}
export const monthYearFromDateObject = (dateObject) => {
  // #deadlines
  if(!dateObject?.year) return ""
  return `${dateObject?.month ? dateObject?.month : 1}/${dateObject?.year}`
}

export const dateObjectToMillis = (dateObject) => {
  // #deadlines
  return new Date(formatDateFromDateObject(dateObject))?.getTime()
}

export const formattedDateObjWithOverMonths = (dateObject, monthsToAdd) => {
  // #deadlines
  const monthsRemainder = monthsToAdd % 12
  const nYears = (monthsToAdd - monthsRemainder)/12

  const newMonths = dateObject?.month + monthsRemainder

  const addedMonths = {month: newMonths, year: dateObject?.year + nYears}
  const overAddedMonths = {month: newMonths - 12, year: dateObject?.year + nYears + 1}

  if(newMonths > 12) return overAddedMonths
  return addedMonths
}

export const currentDateObject = () => {
  // #deadlines
  const today = new Date()
  const doc = {month: today .getMonth() + 1 , year:  today.getFullYear()}
  return doc }

export const addMonthsToDateObject = (dateObject, monthsToAdd) => {

  const currentDate = currentDateObject()
  
  const newDate = formattedDateObjWithOverMonths(dateObject, monthsToAdd)

  const currentDateMillis = dateObjectToMillis(currentDate)
  const dateMillis = dateObjectToMillis(newDate)

  const doc = {...newDate, expired: dateMillis < currentDateMillis ? true : false}
  
  return doc
}

     /** 
* param date checks if the dealine is passed
*/
export const deadlineChecker = (date, notGreen=false) => {
   // #deadlines
   const currentYear = new Date().getFullYear()
   
   if (!date) return ({
    //color:"red",
    nonConformity:false,
    status: "NULL",
    textColor: "white",
    date: undefined
    })

   if (date < currentYear) return ({
       color:"red",
       nonConformity: true,
       status: "OVER",
       textColor: "white",
       date: date
   })
   if (date == currentYear) return ({
       color:"yellow",
       nonConformity:true,
       status: "CURRENT",
       date: date,

   })
   if (date == currentYear + 1) return ({
       color:"blue",
       textColor: "white",
       nonConformity:true,
       status:"NEXT YEAR",
       date: date,
   })

   return {
       color: !notGreen ? "green":"",
       status:"COMPLIANT",
       date: date,
   }
}
export const deadlineObjectChecker = (dateObject, notGreen=false, byMonth=false) => {
  // #deadlines  visualizzato
  const today = currentDateObject()
  const todayMillis = dateObjectToMillis(today)
  const objMillis = dateObjectToMillis(dateObject)
    
  if (!dateObject || (!dateObject?.year && !dateObject?.month )) return ({
   //color:"red",
   nonConformity: false,
   status: "NULL",
   textColor: "white",
   date: undefined
   })

  if (byMonth && objMillis < todayMillis) return ({
    color:"red",
    nonConformity: true,
    status: "OVER",
    textColor: "white",
    date: monthYearFromDateObject(dateObject),
    monthly: true
  }) 
  if (!byMonth && dateObject?.year <= today?.year) return ({
      color:"red",
      nonConformity: true,
      status: "OVER",
      textColor: "white",
      date: monthYearFromDateObject(dateObject)
  })

  if (dateObject?.year == today?.year + 1) return ({
      color:"blue",
      textColor: "white",
      nonConformity: true,
      status:"NEXT YEAR",
      date: monthYearFromDateObject(dateObject),
  })

  return {
      color: !notGreen ? "green":"",
      status:"COMPLIANT",
      date: monthYearFromDateObject(dateObject),
  }
}

export const addZero = (number) => number< 10 ? "0" + number : number

/**
 * 
 * @param {*} date millDate: date in milliseconds from wichi I want to calculate the time passed until now
 * @param {*} justDate bool: if true, always show date, if false shows "now", "... minutes ago", "... hour ago", "... hours ago", "yesterday" and finally the date,
 * @returns formatted date dd/mm/yyyy or string + time passed
 */
export const timePassedTranslated = (date, justDate, dateAndTime) => {
  const { LDB } = useStateContext();
  const now = Date.now()
  const passedMills = now - date
  const milliseconds = Math.floor((passedMills % 1000) / 100)
  const seconds = Math.floor((passedMills / 1000) % 60)
  const minutes = Math.floor((passedMills / (1000 * 60)) % 60)
  const hours = Math.floor((passedMills / (1000 * 60 * 60)) % 24)

  const dateObject = new Date(date)
  const dateSplit = {
      year: dateObject.getFullYear(),
      month: addZero(dateObject.getMonth()+1),
      day: addZero(dateObject.getDate()),
      hours: dateObject?.getHours(),
      minutes: dateObject?.getMinutes() < 10 ? "0" + dateObject?.getMinutes() : dateObject?.getMinutes(),
  }
    const {year,month,day} = dateSplit
    const formattedDate = day + "/" + month + "/" + year
    const formattedTime = dateSplit?.hours + ":" + dateSplit?.minutes
    //console.log("Formatted date", formattedTime)

  if(!justDate && passedMills < 1.728e+8){
    if(passedMills < 120000) return LDB(P, "now")
    if(passedMills < 3.6e+6) return minutes + " " + LDB(P, "minutesAgo")
    if(passedMills < 7.2e+6) return hours + " " + LDB(P, "hourAgo") + " "
    if(passedMills < 8.64e+7) return hours + " " + LDB(P, "hoursAgo")
    if(passedMills < 1.728e+8 && !dateAndTime) return " " + LDB(P, "yesterday")
    if(passedMills < 1.728e+8 &&  dateAndTime) return` ${LDB(P, "yesterday")} alle ${formattedTime}`
  }

  if(dateAndTime) return `${formattedDate} alle ${formattedTime}`
  return formattedDate 
}

export const monthAndYear = (date) => {
  const dateObject = new Date(date)
  const dateSplit = {
      year: dateObject.getFullYear(),
      month: dateObject.toLocaleString('it-IT', { month: 'long' }), // Get full month name
  }

  const { year, month } = dateSplit
  const formattedDate = `${month?.toUpperCase()} ${year}`

  return formattedDate 
}


export const timePassed = (date, justDate) => {
  
  const now = Date.now()
  const passedMills = now - date
  const milliseconds = Math.floor((passedMills % 1000) / 100)
  const seconds = Math.floor((passedMills / 1000) % 60)
  const minutes = Math.floor((passedMills / (1000 * 60)) % 60)
  const hours = Math.floor((passedMills / (1000 * 60 * 60)) % 24)

  //hours = (hours < 10) ? "0" + hours : hours;
  //minutes = (minutes < 10) ? "0" + minutes : minutes;
 // seconds = (seconds < 10) ? "0" + seconds : seconds;
//"h "+ hours + ":" + minutes + ":" + seconds + "." + milliseconds;

  if(!justDate && passedMills < 120000) return "ora"
  if(!justDate && passedMills < 3.6e+6) return minutes + " minuti fa"
  if(!justDate && passedMills < 7.2e+6) return hours + " ora fa "
  if(!justDate && passedMills < 8.64e+7) return hours + " ore fa "
  if(!justDate && passedMills < 1.728e+8) return " ieri"

  const dateObject = new Date(date)
  const dateSplit = {
      year: dateObject.getFullYear(),
      month: addZero(dateObject.getMonth()+1),
      day: addZero(dateObject.getDate())
  }
    const {year,month,day} = dateSplit
    const formattedDate = day + "/" + month + "/" + year
    //console.log("Formatted date", day)

  return formattedDate 
}


export async function createMany (items, query) {
  //query: sanityclient.create(item)
  const promises = items.map?.(async item => {
    await query(item)
  })
  const results = await Promise.all(promises)
  results.forEach(result => {
    //console.log(result)
  })
  // setResults(results)
}

export const windowStorage = () => window.localStorage

export const unique = (objectKey, array) => {
  if (!Array.isArray(array) || array.length === 0 || !objectKey) return [];
  
  const arrayUniqueByKey = [...new Map(array.map?.(item =>
    [item?.[objectKey], item])).values()];
    
  return arrayUniqueByKey;
};


export const updateDevices = (devices, setDevices, device, updateDoc) => {

  const filterDevices = devices.filter?.((x)=>x?._id !== device?._id)
  setDevices([...filterDevices, updateDoc])

}
export const updateRegisters = (registers, setRegisters, register, updatedRegister) => {

  const filterRegisters = registers.filter?.((x)=>x?._id !== register?._id)
  //ADD UPDATED DEVICE TO REGISTER

  setRegisters([...filterRegisters, updatedRegister])
}


export const updateDeviceNonConformities = (array, setData, nonConformity, updateDoc) => {

  let findCurrentDeviceIndex = () => array?.findIndex((x)=>x?._id === nonConformity?._id)
  array.splice(findCurrentDeviceIndex(),1)
  setData([...array, {...updateDoc}])
  //setDevices([...devices, {...updateDoc, comments:device?.comments}])
}


export const exportJSON = (data) => {
  const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
    JSON.stringify(data)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = "data.json";

  link.click();
};

export const nPostazione = (device) => !Array.isArray(device?.locations) ? "" : device?.locations?.find?.(x=>x?.templateField?._ref=="5710d994-8bc9-4981-a5af-94a535d27bbd")?.values?.[0]?.label
export const matricola = (device) => !Array.isArray(device?.fields) ? "" : device?.fields?.find?.(x=>x?.templateField?._ref=="f0fd3f90-ef02-4dae-a4df-dfff44aba409")?.values?.[0]?.label

export const  clientName = (client) => {
  
  if(!client?.notComune) return `COMUNE DI ${client?.label}`
  return client?.label
}

export const successAlert = (title = "") => {
  
  Swal.fire({
      position: 'top',
      icon: 'success',
      title: title,
      showConfirmButton: false,
      timer: 1500
    })
}
export const errorAlertSwal = (title = "") => {
  Swal.fire({
      position: 'top',
      icon: 'error',
      title: title,
      showConfirmButton: false,
      timer: 3500
    })
}
export const errorAlert = (message = "", error = undefined) => {
  const fullErrorMessage = error 
    ? `${message}\n\nError Details:\n${JSON.stringify(error, Object.getOwnPropertyNames(error), 2)}`
    : message;

  toast.error(
    (t) => {
      return React.createElement(
        'div',
        undefined,
        React.createElement('div', undefined,
          React.createElement('p', undefined, message)
        ),
        React.createElement(
          'div',
          { 
            style: { 
              marginTop: '10px', 
              display: 'flex', 
              gap: '10px' 
            } 
          },
          React.createElement(
            'button',
            {
              onClick: () => {
                const mailtoLink = `mailto:info@relyonfm.com?subject=Error Report&body=${encodeURIComponent(fullErrorMessage)}`;
                window.location.href = mailtoLink;
                toast.dismiss(t.id);
              },
              style: {
                padding: '5px 10px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }
            },
            'Spedisci Report Errore'
          ),
          React.createElement(
            'button',
            {
              onClick: () => toast.dismiss(t.id),
              style: {
                padding: '5px 10px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }
            },
            'Chiudi'
          )
        )
      );
    },
    {
      duration: Infinity,
      style: {
        padding: '16px',
        borderRadius: '8px',
        maxWidth: '500px'
      }
    }
  );
};

export const sortByUpdatedAtDate = (a,b) => {
  // Turn your strings into dates, and then subtract them
  // to get a value that is either negative, positive, or zero.
  return new Date(b._updatedAt) - new Date(a._updatedAt);
}
export const sortByUpdatedAtDateDesc = (a,b) => {
  // Turn your strings into dates, and then subtract them
  // to get a value that is either negative, positive, or zero.
  return new Date(a._updatedAt) - new Date(b._updatedAt);
}


export const sortByLabel = ( a, b ) => {

  return a?.label?.trim()?.localeCompare(b?.label?.trim(), undefined, {
    numeric: true,
    sensitivity: 'base'
  })}
  export const sortBySiteNumber = ( a, b ) => {

    return a?.siteNumber?.localeCompare(b?.siteNumber, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

  export const sortByLabelAndDate = ( a, b ) => {
    // Extract dates using regex - matches dd/mm/yyyy format
    const dateRegex = /(\d{2}\/\d{2}\/\d{4})/;
    const dateA = a?.label?.match(dateRegex)?.[0];
    const dateB = b?.label?.match(dateRegex)?.[0];

    // If both items have dates, compare dates first
    if (dateA && dateB) {
      const [dayA, monthA, yearA] = dateA.split('/').map?.(Number);
      const [dayB, monthB, yearB] = dateB.split('/').map?.(Number);
      
      // Create Date objects for comparison
      const dateObjA = new Date(yearA, monthA - 1, dayA);
      const dateObjB = new Date(yearB, monthB - 1, dayB);
      
      if (dateObjA - dateObjB !== 0) {
        return dateObjA - dateObjB;
      }
    }

    // If no dates or dates are equal, compare by label
    return a?.label?.localeCompare(b?.label, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }

  export const sortByLabelDesc = ( a, b ) => {

    return b?.label?.localeCompare(a?.label, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

    export const sortById = ( a, b ) => {

      return a?._id?.localeCompare(b?._id, undefined, {
        numeric: true,
        sensitivity: 'base'
      })}

export const sortByName = ( a, b ) => {

  return a?.name?.localeCompare(b?.name, undefined, {
    numeric: true,
    sensitivity: 'base'
  })}


  export const sortByLastName = ( a, b ) => {

    return a?.lastName?.localeCompare(b?.lastName, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

  export const sortByOrder = ( a, b ) => {

    return a?.order?.toString()?.localeCompare(b?.order?.toString(), undefined, {

      numeric: true,
      sensitivity: 'base'
    })}
  
    export const sortByLocation = ( a, b ) => {

      return a?.location?.toString()?.localeCompare(b?.location?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}

 
    export const sortByDate = ( a, b ) => {

      return a?.date?.toString()?.localeCompare(b?.date?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}

    export const sortByArrayElement = ( a, b ) => {

      return a?.toString()?.localeCompare(b?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}
  
    export const sortBySite = ( a, b ) => {

      return a?.site?.toString()?.localeCompare(b?.site?.toString(), undefined, {
  
        numeric: true,
        sensitivity: 'base'
      })}


  export const sortNumeric = ( a, b ) => {

    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    })}

export const  sortByPostedOn = ( a, b ) => {
    if ( a?.postedOn < b?.postedOn ){
      return -1;
    }
    if ( a?.postedOn > b?.postedOn ){
      return 1;
    }
    return 0;
  }

export const removeEmptyProperties = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter?.(([_, v]) => v != undefined));
  }

export const isIdDraft = (document) => {
  if(document._id?.startsWith("drafts")){
    console.log("DOCUMENT IS IN DRAFT MODE", document)
    return true
  }
  return false
}

/**
 * 
 * @param {*} doc document of _type: device or _type deviceNonConformity
 * @param {*} status string: the new status of the document
 * @returns the updated document ready to be queried
 */
export const updateDeviceStatusDoc = (doc, status) => {

if(doc?._type !== "deviceNonConformity" && doc?._type !== "device") {
  console.log("DOC IS NOT OF TYPE device OR deviceNonConformity")
  return false
}

return ({...doc, status })

}

export const translatedLabel = (item, LDB) => {
  if(item?._id == "5710d994-8bc9-4981-a5af-94a535d27bbd") return LDB("fields", "nPost")
  if(item?._id == "100089e6-e85d-467f-92b2-958628470ea2") return LDB("fields", "floor")
  if(item?._id == "d770ea67-ef56-404d-a7be-37f18f6ea8be") return LDB("fields", "zone")
  if(item?._id == "b049d4bb-67a6-49de-bfb9-5c5df0aedc32") return LDB("fields", "productionYear")
  if(item?._id == "  2f3709d5-b5bc-4971-b17a-af23188319f1") return LDB("fields", "floor")


  
  return item?.label
} 

export const keyId = () => uuidv4().toString().replace(/-/g, '')

export const deviceIndex = (register, device) => register?.devices?.findIndex(x=>x?._id == device?._id)

export const findKey = (register, device) => {
  //register?.devices?.findIndex(x=>x?._id == device?._id)
  const findDeviceKey = !Array.isArray(register?.devices) ? undefined : register?.devices?.find?.(x=>x?._id == device?._id)?._key
  //console.log("device", findDeviceKey)
  return(findDeviceKey)
}

export const optimisticMutation = async (queryClient, queryKey, newDoc, setData) => {
  console.log("OPTIMISTIC MUTATION")
  await queryClient.cancelQueries({ queryKey: [`'${queryKey}'`] })
  const previousDevices = queryClient.getQueryData([`'${queryKey}'`])
  queryClient.setQueryData([`'${queryKey}'`], (old) =>{ 
      const oldData = old?.length > 0 ? old : []
      const newData = [...oldData?.filter?.(x=>old?._id!==newDoc?._id), newDoc]
      setData(newData)
      return newData
  })
  return { previousDevices }
}
export const deviceLogsExpanded = (deviceLogs, users) => { 
        
  return deviceLogs?.map?.((log=>{
      const ref = log?.postedBy?._ref
      const matchUser = !Array.isArray(users) ? {} : users?.find?.(x=>x?._id == ref)
      return ({...log, postedBy: matchUser})
}))}

/**
 * Determines if a device non-conformity is severe.
 * 
 * The function checks if any comments in the device non-conformity are marked as severe and not archived.
 * It also checks if there is a related template non-conformity with a notification.
 * 
 * @param {Object} deviceNonConformity - The non-conformity object related to a specific device.
 * @param {Array} nonConformities - Array of template non-conformity objects.
 * @returns {boolean} - Returns true if the non-conformity is severe, false otherwise.
 */

export const isNonConformitySevere = (deviceNonConformity, nonConformities) => {
  //console.log(templateNonConformity)
  const templateNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities?.find?.((x)=>x?._id==deviceNonConformity?.nonConformity?._ref)
  if(Array.isArray(deviceNonConformity?.comments) && deviceNonConformity?.comments?.filter?.((y)=>y?.status !== "ARCHIVIATO")?.some?.(z=>z?.severe == true)) return true
  if (templateNonConformity?.notification) return true
  return false
}
/**
 * Checks if a device has a severe non-conformity or a severe comment.
 * 
 * A device is considered severe if it has a non-conformity that is severe (i.e. it has a comment marked as severe and not archived)
 * or if it has a comment marked as severe and not archived.
 * 
 * @param {Object} device - The device object to be checked.
 * @param {Array} nonConformities - Array of template non-conformity objects.
 * @returns {boolean} - Returns true if the device is severe, false otherwise.
 */
export const isDeviceSevere = (device, nonConformities) => {
  const activeDeviceNonConformities = !Array.isArray(device?.nonConformities) ? [] : device?.nonConformities.filter?.(nonConformity => nonConformity.status !== "ARCHIVIATO" && nonConformity.status !== "COMPLETATO")
  const severeNonConformityExists = activeDeviceNonConformities?.some?.((x)=>isNonConformitySevere(x, nonConformities))
  const severeCommentExists = Array.isArray(device?.comments) && device?.comments?.filter?.((y)=>y?.status !== "ARCHIVIATO")?.some?.(x=>x?.severe)
  if(severeNonConformityExists) return true
  if(severeCommentExists) return true
  return false
}


  /**
   * @function registerCollections
   * @description Given an array of registers, it will return an object with two properties, devices and nonConformities.
   *              It will iterate over the devices and nonConformities of each register, adding the site and register refs to the devices and nonConformities.
   *              If bypassFilters is true, it will include all nonConformities, otherwise it will only include nonConformities that are not COMPLETATO or ARCHIVIATO.
   *              It will return an object with two properties, devices and nonConformities, which are arrays of objects.
   * @param {Array} registers - An array of registers.
   * @param {boolean} bypassFilters - If true, it will include all nonConformities, otherwise it will only include nonConformities that are not COMPLETATO or ARCHIVIATO.
   * @returns {Object} An object with two properties, devices and nonConformities, which are arrays of objects.
   */

export const registerCollections = (registers, bypassFilters) => {
  if (!Array.isArray(registers) || registers.length === 0) {
    return { devices: [], nonConformities: [] };
  }

  const collections = registers.reduce((acc, register) => {
    if (!register?.devices) return acc;

    // Process devices and nonConformities in a single iteration
    register.devices.forEach(device => {
      // Add device with site and register refs
      const deviceWithRefs = {
        ...device,
        site: {
          _ref: register?.site?._ref,
          _key: register?.site?._key || keyId()
        },
        register: {
          _ref: register?._id,
          _key: register?._key || keyId()
        }
      };
      acc.devices.push(deviceWithRefs);

      // Process nonConformities if they exist
      if (device?.nonConformities?.length) {
        device.nonConformities.forEach(nc => {
          if (bypassFilters || (nc?.status !== "COMPLETATO" && nc?.status !== "ARCHIVIATO")) {
            acc.nonConformities.push({
              ...nc,
              site: deviceWithRefs.site,
              register: deviceWithRefs.register,
              device: {
                _ref: device?._id,
                _key: device?._key || keyId()
              }
            });
          }
        });
      }
    });

    return acc;
  }, { devices: [], nonConformities: [] });

  return collections;
}


export const isDeviceChecked = (device, register) => {
  //#isDeviceChecked
  const lastCheckDate = userLogCheck(device)?.date
  const checkResetDays = register?.checkResetDays ? register?.checkResetDays : 120
  if(lastCheckDate) {
      const now = Date.now()
      const passedMills = now - lastCheckDate
      const nMonths = 1000 * 60 * 60 * 24 * checkResetDays
      if(passedMills < nMonths) return true  
      return false
  }
}

export const screenPosition = () => {
  const chrome = document.documentElement.scrollTop
  const firefox = document.body.scrollTop
  if(chrome !== 0) return chrome
  if(firefox !== 0) return firefox
  
  return 0
}

export const addLogToDoc = (sUser, doc, logType="log", hystoryDoc, position) => {

  const logs = doc?.userLog ? doc?.userLog : []
  const newDoc = {...doc, userLog:[...logs, logDoc(sUser, logType, hystoryDoc, position)]}
  return newDoc
}

export const deviceSubstitutionStatus = ({device, deviceStatus, deadlines, client, bypassDeviceStatus, customDate}) =>  {
  
  const deadlineType = deadlines?.deadlineType

  const isScadCollRev = deadlineType == "Scadenza-Collaudo-Revisione" ? true : false
  const isClientRevision = client?.revision

  const expiry = deadlines?.checkData?.expiry?.date
  const revision = deadlines?.checkData?.revisione?.date
  const test = deadlines?.checkData?.collaudo?.date
  
  const currentYear = customDate ? customDate : new Date().getFullYear()
  //console.log("lsjòszjfòsoijef",{deadlines})
  if(!isClientRevision && isScadCollRev){
    //console.log("isScadCollRev and not isClientRevision")
    if(!expiry && bypassDeviceStatus) return "ATTIVO"
    if(expiry && expiry <= currentYear) return "DA SOSTITUIRE"

    //if(revision && revision <= currentYear) return "DA SOSTITUIRE"
    //if(test && test <= currentYear) return "DA SOSTITUIRE"
    if(bypassDeviceStatus && expiry > currentYear && test > currentYear && revision > currentYear) return "ATTIVO"
    return deviceStatus
  }
  if(!expiry && !bypassDeviceStatus && device?.substituteReason?.value == "SCADUTO") return "ATTIVO"
  if(!expiry && bypassDeviceStatus) return "ATTIVO"
  if(!expiry && !bypassDeviceStatus) return deviceStatus
  if(expiry && expiry <= currentYear) return "DA SOSTITUIRE"

  if(bypassDeviceStatus && expiry && expiry > currentYear) return "ATTIVO"
  if(!bypassDeviceStatus) return deviceStatus
  return "ATTIVO"
}

export const fromBase64ToSanity = async (base64, uploadPhotoAsset=()=>{}) => {
 const response = await fetch(base64)
    ?.then(res => res.blob())
    ?.then(async blob => {
        const options = {
          maxSizeMB: 5, // Maximum file size in MB
          maxWidthOrHeight: 1024, // Resize image to fit within 1024px width or height
          useWebWorker: true, // Use a web worker for better performance
        };
        console.log("...compressing file", blob)
        const compressedBlob = await imageCompression(blob, options);
        const file =  new File([compressedBlob], keyId(),{ type: blob.type })
        //console.log("...compressed file", file)
        const asset = {fileType:"image", file}
        //console.log("hbjehbejhbc", asset)
        return asset
        })
      return response
    }

    export const fromBase64ToSanityOld = async (base64, uploadPhotoAsset=()=>{}) => {
      const response = await fetch(base64)
         ?.then(res => res.blob())
         ?.then(blob => {
             const file =  new File([blob], keyId(),{ type: blob.type })
             console.log(file);
             console.log(blob);
             const asset = {fileType:"image", file}
             //console.log("hbjehbejhbc", asset)
             return asset
             })
           return response
         }

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const resizeBase64 = (base64Image, maxSizeInMB = 0.5) => {
  return new Promise((resolve, reject) => {
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    const img = new Image();
    img.src = base64Image;
    img.onload = function () {
      const canvas = document.createElement("canvas");
      // Enable alpha channel to preserve transparency
      const ctx = canvas.getContext('2d', { alpha: true });
      const width = img.width;
      const height = img.height;
      const aspectRatio = width / height;
      const newWidth = Math.sqrt(maxSizeInBytes * aspectRatio);
      const newHeight = Math.sqrt(maxSizeInBytes / aspectRatio);
      canvas.width = newWidth;
      canvas.height = newHeight;
      
      // Clear canvas with transparent background
      ctx.clearRect(0, 0, newWidth, newHeight);
      
      // Draw image with high quality settings
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      
      // Determine if the original image is PNG (likely has transparency)
      const isPNG = base64Image.indexOf('data:image/png') === 0;
      
      // Use PNG format if original was PNG to preserve transparency, otherwise use JPEG
      let dataURL;
      if (isPNG) {
        dataURL = canvas.toDataURL('image/png');
      } else {
        let quality = 0.8;
        dataURL = canvas.toDataURL('image/jpeg', quality);
      }
      
      resolve(dataURL);
    };
  });
}

export const fromSanityPicToBase64 = async (sanityImage) => {

  const sanityImageUrl = urlFor(sanityImage).url()
  return fetch(sanityImageUrl)
  .then(response => response.blob())
  .then(async blob => {
    return convertBase64(blob)
    .then(base64=>base64)
  });
}

/**
 * 
 * @param {*} latitude latitude First
 * @param {*} longitude longitude Second
 * @returns link to google maps
 */
export const gMapLink = (latitude,longitude) => {
  const long = longitude?.toString()?.replace(/,/g, '.')
  const lat = latitude?.toString()?.replace(/,/g, '.')
  //console.log("LINK GM", long, lat)
  return(`https://www.google.com/maps/search/?api=1&query=${long},${lat}`)
}

export const gMapAddressLink = (address) => {

  //console.log("LINK GM", long, lat)
  return(`https://www.google.com/maps/search/?api=1&query=${address}`)
}

export const siteName = (site) => `PLESSO ${site?.siteNumber}: ${site?.label}`
export const siteNameString = (site) => `PLESSO_${site?.siteNumber}_${site?.label}`

export const labelAndName = (label="", name="") => {
  return `${label} ${name}`
}

export const positionNumber = (device) => {
  const positionId = "5710d994-8bc9-4981-a5af-94a535d27bbd"
  return matchTemplateFieldWithValue(positionId, device?.locations)?.value
} 
export const floor = (device) => {
  const floorId = "100089e6-e85d-467f-92b2-958628470ea2"
  return matchTemplateFieldWithValue(floorId, device?.locations)?.value
} 
export const mergeZone = (device) => {    
  const zoneId = "d770ea67-ef56-404d-a7be-37f18f6ea8be"
  const areaId = "2e587bd1-e26e-4938-9c26-d7c16199ffe6"

  const zoneField = !Array.isArray(device?.locations) ? {} : device?.locations?.find?.((x)=>x?.templateField?._ref == zoneId) 
  const areaField = !Array.isArray(device?.locations) ? {} : device?.locations?.find?.((x)=>x?.templateField?._ref == areaId)

  if(zoneField?.values?.[0]?.label && areaField?.values?.[0]?.label){
      const filteredArray = !Array.isArray(device?.locations) ? [] : device?.locations?.filter?.(x=>x?.templateField?._ref !== zoneId && x?.templateField?._ref !== areaId)
      const updatedArray = [...filteredArray, {...areaField, values:[...areaField?.values, ...zoneField?.values]}]
      return updatedArray
  }
  if(zoneField?.values?.[0]?.label && !areaField?.label){
      const filteredArray = !Array.isArray(device?.locations) ? [] : device?.locations?.filter?.(x=>x?.templateField?._ref !== zoneId)
      const updatedArray = [...filteredArray, {templateField:{_ref: areaId, _type: "reference"}, values:[...zoneField?.values]}]
      return updatedArray
  }
  
  return device?.locations
}
export const deviceAreas = (device) => 
  {
    const areaId = "2e587bd1-e26e-4938-9c26-d7c16199ffe6"
    return matchTemplateFieldWithValue(areaId, mergeZone(device))?.value
  } 

export const deviceInRegister = (deviceId, register) => {
  const findDevice = !Array.isArray(register?.devices) ? [] : register?.devices?.find?.(x=>x?._id == deviceId)
  return findDevice
}

export const isSumZero = (arr) => {
  const sum = arr.reduce((acc, val) => {
    return typeof val === 'number' ? acc + val : acc;
  }, 0);

  return sum === 0;
};

export const euro = (num) => Intl.NumberFormat("de-DE", {
  style: 'currency',
  currency: 'EUR',
}).format(num);

//euro(num)

export const twoDecimals = (num) => Intl.NumberFormat("de-DE", {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
}).format(num);

export const noDecimals = (num) => Intl.NumberFormat("de-DE", {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}).format(num);

//twoDecimals(num)

export const percentage = (num) => Intl.NumberFormat("de-DE", {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format(num / 100);
//percentage(num)

export const formattedNumber = (value, numberFormat) => {
  const dataNumber = Number(value) ? Number(value) : 0
  //if (!dataNumber) return 0
  if(numberFormat == "euro"){return euro(dataNumber)}
  if(numberFormat == "percentage"){return percentage(dataNumber)}
  if(numberFormat == "twoDecimals"){return twoDecimals(dataNumber)}
  return twoDecimals(dataNumber)
}

export const offerTotals = (offerData=[], allOffers=[]) => {
  //ACCOMODATES LABOUR HOURS AND UNITS
  //#showHideOffer
  //#offerTotals
  const value = (customerProduct, valueType) => {
    if(!valueType) return 0
    if(Number(customerProduct?.unit) > 0) return Number(valueType) * Number(customerProduct?.unit)
    return Number(valueType)
    }
  const data = (Array.isArray(offerData) && Array.isArray(allOffers) && allOffers?.lengths > 0 ) ? HiddenOfferData({offerData, allOffers}) 
    : Array.isArray(offerData) ? offerData : []
  const priceToClient = !Array.isArray(data) ? 0 : data
    ?.filter?.((x)=>!x?.hide)
    ?.map?.((x)=>value(x, x?.priceToClient))
    ?.reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
  const profit = !Array.isArray(data) ? 0 : data?.filter?.((x)=>!x?.hide)?.map?.((x)=>value(x, x?.profit))
  ?.reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
  const cost = !Array.isArray(data) ? 0 : data?.filter?.((x)=>!x?.hide).map?.((x)=>value(x, x?.totalCost))
  ?.reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
  const margin = (+profit * 100)/+priceToClient
  const doc = {priceToClient, profit, margin, cost}
  //console.log("hnwjkndewkjdnh",priceToClient)
  return doc
}

export const offerTotalsFormatted = (offerTotals) => {
  //#offerTotals
  if(!offerTotals) return {}
  const priceToClient = euro(Number(offerTotals?.priceToClient || 0))
  const profit = euro(Number(offerTotals?.profit || 0))
  const margin = percentage(Number(offerTotals?.margin || 0))
  const cost = euro(Number(offerTotals?.cost || 0))

  const marginColor = () => {
    if(offerTotals?.margin < 5 ) return "red"
    if(offerTotals?.margin < 25 ) return "amber"
    return "green"
   }


  const doc = {priceToClient, profit, margin, cost, marginColor: marginColor() }

  return doc

 }

 export const fourDigitsToken = () => {
  const randomNum = Math.random() * 9000
  const token = Math.floor(1000 + randomNum)
  return token


}

 export const slugify = (str, addToken=false) => {
  const string = String(str)
  .normalize('NFKD') // split accented characters into their base characters and diacritical marks
  .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
  .trim() // trim leading or trailing whitespace
  .toLowerCase() // convert to lowercase
  .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
  .replace(/\s+/g, '-') // replace spaces with hyphens
  .replace(/-+/g, '-'); // remove consecutive hyphens
  if(addToken) return string+fourDigitsToken()
  return string
}

export const siteAddress = (site) => {
  const address = {
      houseNumber: site?.houseNumber ? `${site?.houseNumber},` : "",
      line1: site?.address1 ? `${site?.address1},` : "",
      line2: site?.address2 ? `${site?.address2},` : "",
      city: site?.city ? site?.city : "",
      postCode: site?.postCode ? `${site?.postCode},` : "", 
      province: site?.province ? `(${site?.province})` : "",   
  }
  const {houseNumber, line1, line2, city, postCode, province} = address
  const fullAddress = `${line1} ${houseNumber} ${line2} ${postCode} ${city} ${province} `
  return fullAddress
}

export const duplicateDeviceFn = (data = {}) => {   
  const {device, client, currentTemplate, register, allPositions, setDateFields, setCurrentLocation, setSubstituteDevice, setSubstituteDeviceFields, setSubstituteReason, setDeviceFields, setDeviceStatus} = data
  // SETS LOCATION, IF AUTO POSITION IS TRUE IN THE REGISTER TEMPLATE, FINDS NEXT AVAILABLE POSITION, IF NOT LEAVES IT BLANK
  const expiry = deadlines(device, currentTemplate, register) 
  
  if(currentTemplate?.autoPosition){
      const nextPosition = () => {
          const findCurrentPositionDoc = !Array.isArray(device?.locations) ? undefined : device?.locations?.find?.(x=>x?.templateField._ref == "5710d994-8bc9-4981-a5af-94a535d27bbd")
          const oldPosition = findCurrentPositionDoc?.values?.length > 0 && findCurrentPositionDoc?.values?.[0]?.value
          const newPosition = () => {
              //const positions = positionsString()
              //const allPositions = positions?.allpositions
              //console.log("ALL POSITIONS", allPositions, "OLD POSITION", +oldPosition)
              for(const position of allPositions) {
                  
                  const nextPosition = position + 1
                  const isNextPositionPresent = allPositions?.some?.((x)=>x == nextPosition)
                  if (nextPosition  > +oldPosition && !isNextPositionPresent) {
                      //console.log("RETURNED POSITION:", nextPosition)
                      return nextPosition
                  } else {
                      //console.log("CURRENT POSITION: ", position, "NEXT POSITION: ", nextPosition, "IS LESS THAN ", +oldPosition, "OR PRESENT IN ", allPositions)
                  }
              }
          }
          const positionDoc = {
              ...findCurrentPositionDoc,
              values:[{
                  value: newPosition()?.toString(),
                  label: newPosition()?.toString(),
                  _key: keyId(),
                  _type: "deviceProperty"
              }]
          }
          return positionDoc
      }
      const locations = !device?.locations ? [] : device?.locations
      //console.log("DUPLICATING DEVICE", positionsString())
      setCurrentLocation ([...!Array.isArray(locations) ? [] : locations?.filter?.(x=>x?.templateField?._ref !== "5710d994-8bc9-4981-a5af-94a535d27bbd"), nextPosition()])
  } else {
      const locations = !device?.locations ? [] : device?.locations
      setCurrentLocation (!Array.isArray(locations) ? [] : locations?.filter?.(x=>x?.templateField?._ref !== "5710d994-8bc9-4981-a5af-94a535d27bbd"))
  }
  setSubstituteDevice(undefined)
  setSubstituteDeviceFields(undefined)
  setSubstituteReason(undefined)
  //  IT DUPLICATES THE FIELDS THAT ARE SET TO BE DUPLICATED IN THE REGISTER TEMPLATE
  const deviceFields =  Array.isArray(device?.fields) ?  device?.fields : []
  const fieldsToDuplicate = deviceFields?.filter?.((x)=>Array.isArray(currentTemplate?.duplicateFields) && currentTemplate?.duplicateFields?.some?.((y)=>y?._ref == x?.templateField?._ref))
  setDeviceFields(fieldsToDuplicate)
  const dateFields =  Array.isArray(device?.dates) ?  device?.dates : []
  const dateFieldsToDuplicate = dateFields?.filter?.((x)=>Array.isArray(currentTemplate?.duplicateFields) && currentTemplate?.duplicateFields?.some?.((y)=>y?._ref == x?.templateField?._ref))
  setDateFields(dateFieldsToDuplicate)
  setDeviceStatus(deviceSubstitutionStatus({device, deviceStatus:"ATTIVO", deadlines: expiry, client}))
  
}

export const filterActiveStatus = (x) => x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO"

export const addOrderToRegister = (register, template) => {
  const updatedOrder = {...register, order: template?.order}
return updatedOrder
}

export const filterLabourProducts = (x) => x?._id !== "d0b3f302-92ef-423b-bd9f-709c35e6dde2" && x?._id !== "34a1fc10-375b-4238-bd37-3a339a70243a"

export const logAnalysis = (devices, registerId) => {

  const checks = devices
      ?.filter?.(x=>{
        if(registerId) return x?.register?._ref == registerId
        return x})
      ?.map?.((x)=>{
        const lastCheck = userLogCheck(x)
        return lastCheck})
      ?.sort(sortByDate)
  
  const dates = checks?.map?.((item, i, array)=>{
      const date = new Date(item?.date)?.toString();

      const secondsBetweenDates = (array[i]?.date - array[i-1]?.date)/1000

      const decimalTimeString = (array[i]?.date - array[i-1]?.date)/60000
      var n = new Date(0,0);
      n.setSeconds(+decimalTimeString * 60 * 60);
      const minAndSec = n.toTimeString().slice(0, 8);

      const doc = {date, check:item, seconds: secondsBetweenDates, minutes: minAndSec, decimalMinutes: decimalTimeString}
      return doc
  })

  console.log("==========LOG ANALYSYS ==========", dates)
  
  return dates
}

export const yesNoAlert = (fn, alertText) => {

  Swal.fire({
      title: alertText,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: "SI'",
      cancelButtonText: "NO",
    }).then((result) => {
      if (result.isConfirmed) {
          fn()
      }
    })
}

export const isMaintenanceIncluded = (client, customerProduct) => {
  const isProductMaintenance = customerProduct?.maintenanceTask
  const isRegisterIncluded = customerProduct?.registers?.some?.((x)=>client?.maintenanceTasksIncluded?.some?.((y)=>y?._ref == x?._ref))
  if(isProductMaintenance && isRegisterIncluded) return true
  return false
}

export const yearsList = (yearsBeyondCurrent = 0) => {
  const firstYear = 1990
  let years = []
  const currentYear = new Date().getFullYear()
  for (let i = firstYear; i <= currentYear + yearsBeyondCurrent; i++){
    years?.push(i)
  }
  return years?.map?.((x)=>({label: x?.toString(), value: x?.toString(), _id: uuidv4(), _key: keyId(), _type: "deviceProperty"}))?.sort(sortByLabelDesc)
}

export const monthsList = () => {

  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map?.((x)=>({label: x?.toString(), value: x?.toString(), _id: uuidv4(), _key: keyId(), _type: "deviceProperty"}))
}

/**
 * Produces a function which uses template strings to do simple interpolation from objects.
 * 
 * Usage:
 *    var makeMeKing = generateTemplateString('${name} is now the king of ${country}!');
 * 
 *    console.log(makeMeKing({ name: 'Bryan', country: 'Scotland'}));
 *    // Logs 'Bryan is now the king of Scotland!'
 */
export const generateTemplateString = (function(){
  var cache = {};

  function generateTemplate(template){
      var fn = cache[template];

      if (!fn){
          // Replace ${expressions} (etc) with ${map.expressions}.

          var sanitized = template
              .replace(/\$\{([\s]*[^;\s\{]+[\s]*)\}/g, function(_, match){
                  return `\$\{map.${match.trim()}\}`;
                  })
              // Afterwards, replace anything that's not ${map.expressions}' (etc) with a blank string.
              .replace(/(\$\{(?!map\.)[^}]+\})/g, '');

          fn = Function('map', `return \`${sanitized}\``);
      }

      return fn;
  }

  return generateTemplate;
})();

export const convertRichEditorDynamicData = (richEditorDocument, dynamicData) => { 

  const richDocWithDynamicValues = richEditorDocument?.blocks?.map?.((block)=>{
      const text = block?.text ? block?.text : ""
      const convertText = generateTemplateString(text)
      const newBlock = {...block, text: convertText(dynamicData)}
      return newBlock
  })
  return richDocWithDynamicValues
  }

 export const commaSeparatedStringToArray = (string) => {
    return string?.split(',')?.map?.((x)=>x?.trim())
 }

 export const discountedPrice = (price, discount) => price - (price * discount / 100 )?.toFixed(2)

 export  const deadlinesData = (device, registerTemplate, sUser) => {
  const deadeline = deadlines(device, registerTemplate)?.checkData?.maintenanceTasksList
  if(deadeline?.length>0) {
      const deadlineDoc = {
          nonConformityId: deadeline[0]?._id,
          ///device,
          deadline: {...deadeline[0], device}
      }
      return {...deviceNonConformityDoc(deadeline[0]?._id, sUser), device}
  }
}

export const copyId = (doc) => {
  return navigator.clipboard.writeText(doc?._id);
}

/**
 * Merges two arrays of objects based on their _id property, with array2 values taking precedence when there's a match.
 * If array1 is not an array, returns an empty array. For each item in array1, if a matching _id is found in array2,
 * uses the array2 item, otherwise keeps the array1 item.
 * 
 * @param {Array} array1 - The base array of objects, each containing an _id property
 * @param {Array} array2 - The array to merge with, its matching items will override array1 items
 * @returns {Array} A new array containing merged items from both arrays, with array2 values taking precedence
 */
export const mergeArraysById = (array1, array2) => {  
  const array1Checked = !Array.isArray(array1) ? [] : array1
  const array2Checked = !Array.isArray(array2) ? [] : array2
  return array1Checked.map?.((item)=>{
    const findField = array2Checked?.find?.((x)=>x?._id == item?._id)
    if(findField){
      return findField
    }
    return item
})
}

export const objectIsObject = (obj) => {
  return typeof obj !== "object" || obj === null ? {} : obj
}
